








































import Vue, { PropType } from 'vue'

import { Comentario, comentario_repository } from '../../../../store/livro-digital/comentarios-repository'
import { Livro } from '../../../../store/livro-digital/livros-repository'
import { Documento } from '../../../../store/livro-digital/documentos-repository'
import Swal from 'sweetalert2'

interface IData {
    comentarios: Comentario[],
    texto: string,
    enviando: boolean
}

export default Vue.extend({
    data(): IData {
        return {
            comentarios: [],
            texto: '',
            enviando: false
        }
    },
    props: {
        livro: {
            type: Object as PropType<Livro>,
            required: true
        },
        CodCondominio: {
            type: Number,
            required: true
        },
        documento: {
            type: Object as PropType<Documento>,
            required: true
        },
        pagina: {
            type: Number,
            required: true
        }
    },
    methods: {
        async loadComentarios() {
            let { ano: Ano, mes: Mes } = this.livro
            let CodCondominio = this.CodCondominio
            let comentarios = await comentario_repository.lista({
                CodCondominio,
                Ano,
                Mes
            })

            this.comentarios = comentarios.filter(comentario => {
                return comentario.Pagina === this.pagina && comentario.IdDocumento === this.documento.IdDocumento
            })
        },
        async send() {
            try {
                if (this.enviando) {
                    return
                }

                const Texto = this.texto.trim()
                if ('' === Texto) {
                    this.texto = this.texto.trim()
                    throw new Error("Preencha o texto de sua consideração")
                }

                let nao_mostrar = []
                try {
                    nao_mostrar = JSON.parse(localStorage.getItem('nao_mostrar_popup')||'[]')
                } catch (err) {
                    nao_mostrar = []
                }

                if (!nao_mostrar.includes(this.livro.CodLivroDigital)) {
                    const { isConfirmed, value } = await Swal.fire({
                        icon: 'warning',
                        title: 'Atenção!',
                        input: 'checkbox',
                        inputValue: 0,
                        inputLabel: "Não perguntar novamente",
                        inputPlaceholder: "Não perguntar Novamente",
                        text: "Ao enviar sua consideração a mesma não poderá ser editada. Deseja continuar?",
                        showCancelButton: true,
                        confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                        target: '.swal-dialog'
                    })
    
                    if (!isConfirmed) {
                        return
                    }
    
                    if (value) {
                        nao_mostrar.push(this.livro.CodLivroDigital)
                        localStorage.setItem('nao_mostrar_popup', JSON.stringify(nao_mostrar))
                    }                 

                }

                this.enviando = true
                const { ano: Ano, mes: Mes } = this.livro
                const CodCondominio = this.CodCondominio
                const { IdDocumento, CodContaCorrente, tipoDocumento: NomeDocumento } = this.documento
                const Pagina = this.pagina
                
                await comentario_repository.incluir({
                    CodCondominio,
                    Mes,
                    Ano,
                    CodContaCorrente,
                    IdDocumento,
                    NomeDocumento,
                    Pagina,
                    Texto
                })
                await this.loadComentarios()
            } catch (err: any) {
                console.error(err)
                const text = err.response?.data?.error || err.response?.data?.message || err.message || "Não foi possível enviar sua consideração"
                await Swal.fire({
                    icon: "error",
                    title: "Oops",
                    text,
                    target: '.swal-dialog'
                })
            } finally {
                this.enviando = false
            }
        },
        close() {
            const $el = this.$el as HTMLDialogElement
            this.$emit('close')
            
            //$el.close()

        }
    },
    async mounted() {
        this.loadComentarios()
        const $el = this.$el as HTMLDialogElement
        $el.showModal()        
        
    }
})

